export const CREATE_SUBSCRIPTION = "CREATE_SUBSCRIPTION";
export const CREATE_SUBSCRIPTION_SUCCESS = "CREATE_SUBSCRIPTION_SUCCESS";
export const CREATE_SUBSCRIPTION_ERROR = "CREATE_SUBSCRIPTION_ERROR";

export const GET_ALL_SUBSCRIPTION = "GET_ALL_SUBSCRIPTION";
export const GET_ALL_SUBSCRIPTION_SUCCESS = "GET_ALL_SUBSCRIPTION_SUCCESS";
export const GET_ALL_SUBSCRIPTION_ERROR = "GET_ALL_SUBSCRIPTION_ERROR";

export const GET_MASTERS = "GET_MASTERS";
export const GET_MASTERS_SUCCESS = "GET_MASTERS_SUCCESS";
export const GET_MASTERS_ERROR = "GET_MASTERS_ERROR";

// delete
export const DELETE_PLAN = "DELETE_PLAN";
export const DELETE_PLAN_SUCCESS = "DELETE_PLAN_SUCCESS";
export const DELETE_PLAN_ERROR = "DELETE_PLAN_ERROR";
// edit
export const EDIT_PLAN = "EDIT_PLAN";
export const EDIT_PLAN_SUCCESS = "EDIT_PLAN_SUCCESS";
export const EDIT_PLAN_ERROR = "EDIT_PLAN_ERROR";
// update
export const UPDATE_PLAN = "UPDATE_PLAN";
export const UPDATE_PLAN_SUCCESS = "UPDATE_PLAN_SUCCESS";
export const UPDATE_PLAN_ERROR = "UPDATE_PLAN_ERROR";

// update visibility status
export const UPDATE_VISIBILITY_STATUS = "UPDATE_VISIBILITY_STATUS";
export const UPDATE_VISIBILITY_STATUS_SUCCESS = "UPDATE_VISIBILITY_STATUS_SUCCESS";
export const UPDATE_VISIBILITY_STATUS_ERROR = "UPDATE_VISIBILITY_STATUS_ERROR";
